import { cn } from '@/shared/lib/cn';

interface Props {
    message?: string;
    className?: string;
}

export function InputError({ message, className }: Props) {
    if (!message) return null;
    return <p className={cn('text-sm text-red-600 dark:text-red-500', className)}>{message}</p>;
}
